export default "__VITE_ASSET__peSPBor8__"